import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { MarcaService } from '../../../../shared/services/apis/produto/marca.service';
import { MarcaRequest } from '../../../../shared/services/requests/produto/marca.request';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-marca-cadastro',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    HeaderComponent,
    LoadingBoxComponent,
    FooterActionComponent,
    MatProgressSpinnerModule,
  ],
  templateUrl: './marca-cadastro.component.html',
  styleUrl: './marca-cadastro.component.css',
})
export class MarcaCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Cadastros;

  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public idMarca: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private marcaService: MarcaService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.createForm();

    this.route.params.subscribe(params => {
      if (params['idMarca']) {
        this.idMarca = +params['idMarca'];
        this.isEdicao = true;
        this.carregarMarca();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      nome: ['', Validators.required],
    });
  }

  private carregarMarca(): void {
    this.isLoading = true;
    this.marcaService.getById(this.idMarca).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Erro ao carregar marca.', AlertType.error);
          this.voltar();
          return;
        }

        if (res.listaMarcas && res.listaMarcas.length > 0) {
          const marca = res.listaMarcas[0];
          this.form.patchValue({
            nome: marca.nome,
          });
        } else if (res.marca) {
          this.form.patchValue({
            nome: res.marca.nome,
          });
        }
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar a marca.', AlertType.error);
        console.error(err);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.alertService.show('Atenção', 'Não é possível salvar uma marca sem nome.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    const request: MarcaRequest = this.form.value;

    if (this.isEdicao) {
      this.marcaService.update(this.idMarca, request).subscribe({
        next: res => this.tratarRetornoSalvar(res),
        error: err => this.tratarErroSalvar(err),
      });
    } else {
      this.marcaService.create(request).subscribe({
        next: res => this.tratarRetornoSalvar(res),
        error: err => this.tratarErroSalvar(err),
      });
    }
  }

  private tratarRetornoSalvar(res: any): void {
    this.isSaving = false;
    if (res.isError) {
      const msg =
        res.errorDescription && res.errorDescription.toLowerCase().includes('duplicate')
          ? 'Já existe uma marca com este nome informado.'
          : res.errorDescription || 'Erro ao salvar marca.';

      this.alertService.show('Atenção', msg, AlertType.warning);
    } else {
      this.alertService.show('Sucesso', 'Marca salva com sucesso.', AlertType.success);
      this.voltar();
    }
  }

  private tratarErroSalvar(err: any): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar.', AlertType.error);
    console.error(err);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/cadastros/marcas']);
  }
}
